import FilterTemplate from "src/components/Layouts/FilterTemplate";
import useRenderFilterFields from "./hooks/useRenderFilterFields";
import AddLedgerBalanceMonitorButton from "./components/AddLedgerBalanceMonitorButton";
import AddLedgerBalanceMonitorDialog from "./components/AddLedgerBalanceMonitorDialog";
import AddLedgerBalanceMonitorDialogProvider from "src/features/DialogProvider";
import { FeatureCode } from "@wallet-manager/node-types";

function Filter() {
  const { renderFields } = useRenderFilterFields();

  return (
    <FilterTemplate
      extraButtons={
        <AddLedgerBalanceMonitorDialogProvider
          permissionKey={FeatureCode.FeaturesLedger.LedgerBalanceMonitor.Add}
        >
          <AddLedgerBalanceMonitorButton />
          <AddLedgerBalanceMonitorDialog />
        </AddLedgerBalanceMonitorDialogProvider>
      }
      renderFields={renderFields}
    />
  );
}

export default Filter;
